import { type ReactNode } from 'react'
import { mtc } from '@/styles'

interface SignupFormFieldsWrapperProps {
  children: ReactNode
  className?: string
}

export const SignupFormFieldsWrapper = ({
  children,
  className,
}: SignupFormFieldsWrapperProps) => (
  <div className={mtc('max-w-[400px] w-full', className)}>{children}</div>
)
